import { createContext, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

export const CardUsageTabContext = createContext(null);

export function CardUsageTabProvider({ children }) {
  const [searchParams, setSearchParams] = useSearchParams();

  const [currentStartDate, setCurrentStartDate] = useState(null);
  const [currentEndDate, setCurrentEndDate] = useState(null);
  const [currentSelectedDivisions, setCurrentSelectedDivisions] =
    useState(null);

  const urlCardName = searchParams.get("card_name");
  const urlOpen = searchParams.get("open");
  const urlMainDeckType = searchParams.get("main_deck_type");
  const urlSubDeckType = searchParams.get("sub_deck_type");
  const urlCardNameQueryList = searchParams.get("card_name_query_list");

  const [cardName, setCardName] = useState(urlCardName || []);
  const [currentCardName, setCurrentCardName] = useState("");
  const [open, setOpen] = useState(urlOpen === "true");
  const [mainDeckType, setMainDeckType] = useState(
    urlMainDeckType || "指定なし",
  );
  const [subDeckType, setSubDeckType] = useState(urlSubDeckType || "指定なし");
  const [cardNameQueryList, setCardNameQueryList] = useState(
    urlCardNameQueryList
      ? JSON.parse(urlCardNameQueryList)
      : [{ card_names: [], card_num: 1, condition: "以上" }],
  );

  const [isBeforeSearch, setIsBeforeSearch] = useState(true);

  const [items, setItems] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (
      urlCardName ||
      urlOpen ||
      urlMainDeckType ||
      urlSubDeckType ||
      urlCardNameQueryList
    ) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("card_name");
      newParams.delete("open");
      newParams.delete("main_deck_type");
      newParams.delete("sub_deck_type");
      newParams.delete("card_name_query_list");
      setSearchParams(newParams);
    }
  }, [
    urlCardName,
    urlOpen,
    urlMainDeckType,
    urlSubDeckType,
    urlCardNameQueryList,
    searchParams,
    setSearchParams,
  ]);

  return (
    <CardUsageTabContext.Provider
      value={{
        currentStartDate,
        setCurrentStartDate,
        currentEndDate,
        setCurrentEndDate,
        currentSelectedDivisions,
        setCurrentSelectedDivisions,
        cardName,
        setCardName,
        currentCardName,
        setCurrentCardName,
        open,
        setOpen,
        mainDeckType,
        setMainDeckType,
        subDeckType,
        setSubDeckType,
        cardNameQueryList,
        setCardNameQueryList,
        isBeforeSearch,
        setIsBeforeSearch,
        items,
        setItems,
        error,
        setError,
      }}
    >
      {children}
    </CardUsageTabContext.Provider>
  );
}
